module.exports = __webpack_public_path__ + "img/illustration-categories-3-mobile.9e38289d.gif";